import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FormContextProvider, DisplaySpinnerContext } from "../../../context/ContextIndex";
import { AppForm, DynamicFormContainer, notifyToast, ToastType, TabPanel } from "../../../components";
import { getPricingSettingsDefaultValue, getPricingSettingsSchema } from "./Schema";
import { selectSessionConfig } from "../../../store/store-selector";
import { savePricingSettings } from "../api-handler/api-handler";
import AppFormRootContainer from "../../../components/app-components/app-form-root-container/AppFormRootContainer";

const CreatePricingSettingsForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const EditPricingSettingsId = searchParams.get("pricingsettingsid");
  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);
  const navigationData = location.state;

  const [formdata, setFormdata] = useState({
    schema: getPricingSettingsSchema(),
    appformdata: null,
  });

  const defaultValue = getPricingSettingsDefaultValue();

  const handleCancel = () => {
    try {
      navigate("/pricingsettingslist");
    } catch (err) {
      alert(err);
    }
  };

  const onPricingSettingsSubmit = async (data, formhandler) => {
    console.log("onPricingSettingsSubmit");
    const { reset, clearErrors } = formhandler;
    try {
      clearErrors();
      spinnerCtx.setLoadingIndicator(true);
      const status = await savePricingSettings(data, {
        EditPricingSettingsId,
        settingsConfig,
        formdata: formdata.appformdata,
      });

      if (status?.responseStatus === 200) {
        notifyToast("Sent for Approval", ToastType.SUCCESS);
        handleCancel();
      } else {
        notifyToast(status.errorMessage ? status.errorMessage : "Pricing Settings creation failed", ToastType.ERROR);
        spinnerCtx.setLoadingIndicator(false);
      }
      if (status?.error) {
        reset(
          { ...data },
          {
            keepValues: true,
            keepSubmitCount: false,
            keepDirty: true,
            keepTouched: true,
          }
        );
      }
    } catch (err) {
      reset(
        { ...data },
        {
          keepValues: true,
          keepSubmitCount: false,
          keepDirty: true,
          keepTouched: true,
        }
      );
      alert(err);
    }
  };

  useEffect(() => {
    const setFormSchema = () => {
      try {

        let _formData = navigationData ? { ...navigationData } : null;

        if (_formData) {
          setFormdata((prevstate) => ({
            ...prevstate,
            schema: getPricingSettingsSchema(),
            appformdata: getPricingSettingsDefaultValue(_formData),
          }));
        } else {
          setFormdata((prevstate) => ({
            ...prevstate,
            schema: getPricingSettingsSchema(),
          }));
        }

      } catch (err) {
        alert(err);
      } finally {
        spinnerCtx.setLoadingIndicator(false);
      }
    };

    spinnerCtx.setLoadingIndicator(true);
    setFormSchema();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppFormRootContainer>
      <TabPanel
        tabs={[
          {
            icon: "",
            label: t("pricingSettingsList.header"),
            children: (
              <FormContextProvider schema={formdata.schema} defaultValues={defaultValue} appformdata={formdata.appformdata}>
                <AppForm onSubmit={onPricingSettingsSubmit}>
                  <DynamicFormContainer
                    header={EditPricingSettingsId ? t("createPricingSettings.editPricingSettings") : t("createPricingSettings.header")}
                    onCancel={handleCancel}
                  />
                </AppForm>
              </FormContextProvider>
            ),
          },
        ]}
        selectedTab="0"
        onTabChange={() => { }}
      />
    </AppFormRootContainer>
  );
};

export default CreatePricingSettingsForm;
